import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProduto } from '../../models/'
import { IProdutoTipoConsumo } from "../../models/IProduto";

interface IProdutoState{
    produtos: IProduto[]
    produtoSelecionado?: IProduto
    produtosTipoConsumo: IProdutoTipoConsumo[]
}

const initialState: IProdutoState = {
    produtos: [],
    produtosTipoConsumo: []
} 

const produtoSlice = createSlice({
    name: 'Produto',
    initialState,
    reducers: {
        setProdutoState(state, action:PayloadAction<IProduto>) {
            state.produtoSelecionado = action.payload
        },
        resetVendedoresState(state) {
            state.produtos = initialState.produtos
        },
        setProdutosTipoConsumoState(state, action: PayloadAction<IProdutoTipoConsumo[]>) {
            state.produtosTipoConsumo = action.payload
        },
        resetProdutosTipoConsumoState(state) {
            state.produtosTipoConsumo = initialState.produtosTipoConsumo
        }
    }
})

export const {
      resetProdutosTipoConsumoState,
      resetVendedoresState,
      setProdutoState,
      setProdutosTipoConsumoState
} = produtoSlice.actions

export const produtoReducer = produtoSlice.reducer 